export const Arch = ({ color }) => {
	const style1 = { fill: "none" };
	const style2 = {
		fill: "none",
		stroke: color,
		strokeMiterLimit: 10,
		strokeWidth: "17px",
	};
	const style3 = { clipPath: "url(#clippath)" };
	const style4 = { fill: "white" };
	return (
		<svg
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 1623.13 887.88"
		>
			<defs>
				<clipPath id="clippath">
					<rect style={style1} y="73.82" width="1035.42" height="524.75" />
				</clipPath>
			</defs>
			<g style={style3}>
				<rect
					style={style2}
					x="34.92"
					y="101.77"
					width="1167.82"
					height="609.1"
					rx="78.04"
					ry="78.04"
				/>
				<polygon
					style={style4}
					points="1623.13 0 1035.42 0 1035.42 598.57 0 598.57 0 887.88 1306.89 887.88 1306.89 708.31 1623.13 708.31 1623.13 0"
				/>
			</g>
		</svg>
	);
};

export const archCss = {
    position: "absolute",
    top: "9.4%",
    left: "22.2%",
    width: "84.8%",
}